var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSectionD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_830_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0703 29.4492C42.0703 32.6654 41.4844 35.3542 40.3125 37.5156C39.1406 39.6641 37.4414 41.2852 35.2148 42.3789C33.0013 43.4596 30.3125 44 27.1484 44H19.3945V15.4453H28.0078C30.9115 15.4453 33.4115 15.9792 35.5078 17.0469C37.6042 18.1016 39.2188 19.6706 40.3516 21.7539C41.4974 23.8242 42.0703 26.3893 42.0703 29.4492ZM38.5742 29.5664C38.5742 27.0013 38.1445 24.8854 37.2852 23.2188C36.4388 21.5521 35.1888 20.3151 33.5352 19.5078C31.8945 18.6875 29.8828 18.2773 27.5 18.2773H22.7148V41.1484H26.7578C30.6901 41.1484 33.6393 40.1784 35.6055 38.2383C37.5846 36.2982 38.5742 33.4076 38.5742 29.5664Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_830_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionD);
export default __webpack_public_path__ + "static/media/section-d.a78c0a64b821122210beda42a3910978.svg";
export { ForwardRef as ReactComponent };